import React from "react";
import { FiChevronRight } from "react-icons/fi";
import { useNavigate } from "react-router-dom";

const ProviderStatistcCard = ({
  title,
  value,
  link,
  providerId,
  providerName,
  type,
}) => {
  const navigate = useNavigate();
  return (
    <>
      <div className="w-full bg-white rounded-2xl p-3">
        <p className="text-black">{title}</p>
        <div className="flex justify-between mt-3">
          <p className="text-[#284184] font-semibold text-3xl">{value}</p>
          {link && (
            <button
              onClick={() =>
                navigate(link, { state: { providerId, providerName, type } })
              }
            >
              <FiChevronRight className="text-xl" />
            </button>
          )}
        </div>
      </div>
    </>
  );
};

export default ProviderStatistcCard;
